module.exports = __webpack_public_path__ + "img/arrow_down_circle.d542d1af.svg";